(() => {
  function initialize(root) {
    const grid = root.querySelector('.jjt-plp__grid');
    const pagination = root.querySelector('[data-jjt-pagination]');
    const button = pagination?.querySelector('[data-jjt-show-more]');
    if (!grid || !button || root.dataset.jjtPaginationReady) return;
    root.dataset.jjtPaginationReady = 'true';
    const status = pagination.querySelector('[data-jjt-pagination-status]');
    const error = pagination.querySelector('[data-jjt-pagination-error]');
    const fallback = error.querySelector('a');
    const label = button.textContent;
    let loading = false;

    function productKey(card) {
      const href = card.querySelector('.jjt-card__title')?.getAttribute('href');
      return href ? new URL(href, document.baseURI).href : null;
    }

    button.hidden = false;
    button.addEventListener('click', async event => {
      if (loading || !button.dataset.nextUrl) return;
      loading = true;
      button.disabled = true;
      button.textContent = button.dataset.loadingLabel;
      grid.setAttribute('aria-busy', 'true');
      error.hidden = true;
      status.textContent = '';
      const keyboard = event.detail === 0;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 20000);
      try {
        const url = new URL(button.dataset.nextUrl, document.baseURI);
        if (url.origin !== new URL(document.baseURI).origin) throw new Error('Invalid collection URL');
        url.searchParams.set('section_id', root.dataset.jjtSectionId);
        const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Collection could not be loaded');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextRoot = parsed.querySelector('[data-jjt-plp]');
        const nextGrid = nextRoot?.querySelector('.jjt-plp__grid');
        if (!nextGrid) throw new Error('Missing collection grid');
        const existing = new Set(Array.from(grid.children).filter(card => card.matches('.jjt-card')).map(productKey));
        const cards = Array.from(nextGrid.children).filter(card => {
          if (!card.matches('.jjt-card')) return false;
          const key = productKey(card);
          if (!key || existing.has(key)) return false;
          existing.add(key);
          return true;
        });
        if (!cards.length) throw new Error('No new products were returned');
        const fragment = document.createDocumentFragment();
        cards.forEach(card => fragment.append(card));
        grid.append(fragment);
        const next = nextRoot.querySelector('[data-jjt-show-more]')?.dataset.nextUrl || '';
        button.dataset.nextUrl = next;
        fallback.href = next || document.baseURI;
        button.hidden = !next;
        pagination.classList.toggle('is-complete', !next);
        root.dispatchEvent(new CustomEvent('jjt:products-added', { detail: { cards } }));
        status.textContent = button.dataset.loadedLabel.replace('__COUNT__', String(cards.length))
          + (next ? '' : ' ' + button.dataset.completeLabel);
        if (keyboard) cards[0].querySelector('.jjt-card__title')?.focus({ preventScroll: true });
      } catch {
        error.hidden = false;
      } finally {
        window.clearTimeout(timeout);
        loading = false;
        button.disabled = false;
        button.textContent = label;
        grid.removeAttribute('aria-busy');
      }
    });
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-jjt-plp]').forEach(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
